

const columnList: Array<any> = [
    {
        prop: "order_sn",
        label: "工单编号",
        width: 124,
    },
    {
        prop: "create_time_text",
        label: "工单结算时间",
        width: 124,
    },
    {
        prop: "user_id",
        label: "用户id",
        width: 82,
    },
    {
        prop: "project_type_name",
        label: "类型",
        width: 82,
    },
    {
        prop: "vip_card",
        label: "尊享卡名称",
        width: 164,
    },
    {
        prop: "vip_class",
        label: "尊享卡项目名称",
        width: 164,
    },
    {
        prop: "project_name",
        label: "已购项目名称",
        width: 164,
    },
    {
        prop: "money",
        label: "金额",
        width: 82,
    },
    {
        prop: "settlement_text",
        label: "是否已结算",
        width: 82,
    },
    {
        prop: "settle_time_text",
        label: "结算时间",
        width: 124,
    }
];

import { defineComponent, inject, ref, onMounted, reactive } from "vue";
import { getOrderTable } from "@/api/http";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

export default defineComponent({
    name: "AdminCashCenter",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["平台结算"]);
        const headClass = inject("headClass");
        let loading = ref(false),
            userinfo = ref(false),
            tableData = ref([] as Array<any>),
            currentPage = ref(1),
            pageSize = ref(10),
            total = ref(1),
        screenParameter = reactive({
            time:new Date()
        });
        
        let getTableData = () => {
                loading.value = true;
                let time = Math.floor(screenParameter.time.getTime()/1000);
                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/storeCashCenter',
                    data: {page:currentPage.value,pagesize:pageSize.value,time:time}
                }).then((res: any) => {
                    tableData.value = res.content.list;
                    total.value = res.content.total;
                    loading.value = false;
                })
            },
            selectChange = (e: any,key: any): void => {
                // if (key == 'time'){
                //     if(e){
                //         screenParameter.time = ((e as Date).getTime()/1000) + 259200;
                //     }else {
                //         screenParameter.time = 0;
                //     }
                // }
        
                getTableData();
            },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            };
        onMounted(async() => {
            getTableData();
        });
        
        return {
            loading,
            tableData,
            headClass,
            getTableData,
            currentPage,
            pageSize,
            columnList,
            total,
            handleSizeChange,
            handleCurrentChange,
            screenParameter,
            selectChange
        };
    },
});
